export default __webpack_public_path__ + "static/media/presofis_plaqad_logo_home.a6d9b7b5.svg";